{
    "ENV": {
        "TITLE": "Fixteam Drenthe | Staging",
        "API": "https://staging.api.epf.fixteamdrenthe.nl",
        "WEBSOCKET": "",
        "QR_LOGIN": "",
        "QR_LOGIN_REFRESH_RATE": "",
        "QR_LOGIN_CHECK_RATE": "",
        "MSAL_CLIENT_ID": "fc0c8573-fe74-4809-99ac-aad548f30ef0",
        "MSAL_TENANT_ID": "",
        "MSAL_AUTHORITY": "https://drentheepf.b2clogin.com/drentheepf.onmicrosoft.com/B2C_1_Staging_SignupAndSignin",
        "MSAL_KNOWN_AUTHORITIES": "https://drentheepf.b2clogin.com",
        "HAS_VIDEO": "",
        "MAP_KEY": "",
        "MAP_ID": "",
        "DEBUG": ""
    }
}